import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Seo from '../Components/Seo';
import { formatInr } from '../data/pricingPlans';
import { breadcrumbSchema, organizationSchema } from '../data/seo';
import '../assests/css/pricing.css';

function PaymentSuccess() {
  const { state } = useLocation();
  const orderId = state?.orderId || '';
  const paymentId = state?.paymentId || '';
  const amount = state?.amount;
  const planName = state?.planName || 'your plan';
  const name = state?.name || '';

  return (
    <div className="pricing-page">
      <Seo
        path="/pricing/success"
        noIndex
        schema={[organizationSchema, breadcrumbSchema('/pricing/success', 'Payment Successful')]}
      />
      <Header />
      <main className="pricing-main">
        <section className="pricing-section">
          <div className="container">
            <div className="pricing-success-card">
              <p className="pricing-kicker">Payment received</p>
              <h1>Thank you{name ? `, ${name}` : ''}</h1>
              <p className="pricing-lead">
                Your payment for the {planName} plan was successful. Our team will contact you with
                onboarding and setup next steps.
              </p>

              <dl className="pricing-success-meta">
                {orderId ? (
                  <div>
                    <dt>Order ID</dt>
                    <dd>{orderId}</dd>
                  </div>
                ) : null}
                {paymentId ? (
                  <div>
                    <dt>Payment ID</dt>
                    <dd>{paymentId}</dd>
                  </div>
                ) : null}
                {amount ? (
                  <div>
                    <dt>Amount</dt>
                    <dd>{formatInr(amount)}</dd>
                  </div>
                ) : null}
                <div>
                  <dt>Status</dt>
                  <dd>SUCCESS</dd>
                </div>
              </dl>

              <div className="pricing-success-actions">
                <Link className="pricing-buy pricing-buy-filled" to="/pricing">
                  Back to pricing
                </Link>
                <Link className="pricing-buy pricing-buy-outline" to="/contact-us">
                  Contact us
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PaymentSuccess;
